exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#available-course,#card-course,#folio-course,#modality-course,#nivel-course,#start-date-course,#timezone-course{font-size:1rem;margin-top:5px!important}#title-hour>.col{padding:0}", ""]);

// exports
